module.exports = __webpack_public_path__ + "static/media/fast-backward.51f1b1da.svg";